/**
 * Represents a single test phase item sourced from the API.
 * Maps to the GET /api/telemetry/v2/twins/groups/{groupId}/teststates response.
 */
export interface TestPhaseItem {
  /** User who created the phase */
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
  /** Unique identifier from the API */
  identifier: string;
  /** Display name (user-editable) */
  phaseName: string;
  /** Original name from the API */
  origName: string;
  /** Associated configuration (group) ID */
  configurationId: string;
  /** Start date of the test phase */
  startDate: string;
  /** End date of the test phase */
  endDate: string;
  /** Original start date (before any user edits) */
  startOrigDate: string;
  /** Original end date (before any user edits) */
  endOrigDate: string;
  /** Hex color for visualization */
  color: string;
  /** Whether this phase is visible in the chart */
  visible: boolean;
  /** User who approved (null if not approved) */
  approvedBy: string | null;
  /** Whether the phase has been approved */
  isApproved: boolean;
}

/**
 * State model for test phase analysis
 */
export interface TestPhaseStateModel {
  /** List of test phases from the API */
  phases: TestPhaseItem[];
  /** Set of hidden phase identifiers */
  hiddenPhaseIds: string[];
  /** Set of hidden phase values */
  hiddenPhaseValues: number[];
  /** Loading state */
  isLoading: boolean;
  /** Error message if any */
  error: string | null;
}

/**
 * Default state values
 */
export const TEST_PHASE_STATE_DEFAULTS: TestPhaseStateModel = {
  phases: [],
  hiddenPhaseIds: [],
  hiddenPhaseValues: [],
  isLoading: false,
  error: null,
};
